import Link from 'next/link';
import CategoryLabel from '../category/CategoryLabel';
import DateLabel from '../date/DateLabel';
import { CardProps } from './types';
import { FfbbsiteCategories } from '@/lib/directus';

export default function PageCard({
  callToActionUrl: { url, external, slug },
  category,
  isoDate,
  title,
}: CardProps) {
  const link = external ? url : `${url}/${slug}`;
  const target = external ? '_blank' : '_self';

  const categoryItem =
    Array.isArray(category) && category.length > 0 && category[0]?.ffbbsite_categories_id
      ? ((category[0]?.ffbbsite_categories_id as FfbbsiteCategories)?.title as string)
      : null;

  return (
    <div className={`flex h-[69px] w-full items-center rounded-md bg-white p-[14px]`}>
      <Link href={link} target={target} className="flex items-center justify-start gap-5 lg:ml-20">
        {categoryItem && (
          <div className="text-gray-400">
            {Array.isArray(category) && category.length > 0 && (
              <CategoryLabel category={categoryItem || ''} />
            )}
          </div>
        )}
        <div className="text-gray-400">
          {isoDate && <DateLabel isoDate={isoDate || ''} styles="text-sm" type="dd/MM/yyyy" />}
        </div>
        <div className="text-sm font-bold text-slate-950">{title}</div>
      </Link>
    </div>
  );
}
